export const requestIntention = {
	LOAD: "LOAD",
	RELOAD: "RELOAD",
	BACKGROUND: "BACKGROUND"
};

export const defaultFretAmount = 21;
